import { render, staticRenderFns } from "./ShowView.vue?vue&type=template&id=6d031737&scoped=true"
import script from "./ShowView.vue?vue&type=script&lang=js"
export * from "./ShowView.vue?vue&type=script&lang=js"
import style0 from "./ShowView.vue?vue&type=style&index=0&id=6d031737&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d031737",
  null
  
)

export default component.exports